/*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description: 
 */
 <!-- 
  模拟生产
 -->
<template>
  <div class="list simulation-produce">
    <div class="children-head">
      <h1 class="title">
        <span slot="title">模拟生产</span>
        <span class="version">公测版</span>
        <span class="hint">此模块为测试版本，不属于现阶段收费范畴，期待与您进行需求共创！</span>
      </h1>
    </div>
    <div class="commun-wrap" v-loading="loading" element-loading-text="开始模拟...">
      <div class="field-out">
        <label for="sheetNo" class="el-form-item__label" style="width: 124px;">选择BOM</label>
        <bom-field
        :module="moduleName"
        :item="simulationItem"
        :form="simulationForm"
        @emitObj="bomChange">
        </bom-field>
        <el-button 
          class="save" 
          type="primary" 
          :disabled="!bomObj.id"
          @click="startSimulation">
          开始模拟
        </el-button>
      </div>
      <div class="simulation-table">
        <table class="tableclass" cellspacing="0" cellpadding="0"border="0">
          <tbody>
            <tr>
              <td>BOM</td>
              <td>
                <template v-if="bomNo">
                  <span>关联BOM清单：{{bomName}}（编号{{bomNo}}）</span>
                  <span>BOM版本：{{bomVersion}}</span>
                </template>
                <span v-else class="no-bom">请选择BOM后模拟生产</span>
              </td>
            </tr>
            <tr>
              <td>物料</td>
              <td>
                <el-table
                  v-if="bomNo"
                  border
                  max-height="400"
                  :data="materielTableData"
                  style="width:100%">
                  <el-table-column v-for="(h,index) in materielExplains"
                    :label="h.attrName"
                    :prop="h.attr"
                    :key="h.attr"
                    v-if="h.attr !== 'unitNum'">
                    <template slot-scope="scope">
                      <template v-if="h.attr==='warehouse'">
                        <el-select
                          size="small"
                          v-model="scope.row.result[index].attrValue"
                          @change="changeWareHouse(scope.$index, scope.row.result[index].attrValue)"
                          value-key="id"
                          placeholder="请选择">
                            <el-option
                              v-for="op in scope.row.result[index].warehouseArray"
                              :key="op.id"
                              :label="op.value"
                              :value="op">
                            </el-option>
                        </el-select>
                      </template>
                      <!-- 库存 -->
                      <template v-else-if="h.attr==='stock'">
                        {{scope.row.result[index].attrValue || 0}}
                      </template>
                      <template v-else-if="[5,6,8,10].indexOf(h.fieldType) === -1">
                        <span>{{scope.row.result[index].attrValue || '--'}}</span>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                <span v-else class="no-bom">请选择BOM后模拟生产</span>
              </td>
            </tr>
            <tr>
              <td>成品</td>
              <td>
                <div class="ed-product" v-if="bomNo">
                  <img :src="finishedProduct.thumbnail" @click="imgBig(finishedProduct.thumbnail)"/>
                  <div class="product-Info">
                    <p>产品名称：{{finishedProduct.productName || '--'}}</p>
                    <p>产品编号：{{finishedProduct.productNo || '--'}}</p>
                    <p>规格：{{finishedProduct.specification || '--'}}</p>
                  </div>
                  <div class="product-Num">
                    <p>库存总数量：{{finishedProduct.stock}}</p>
                    <p>可生产数量：{{simulationForm.canNum}}
                      <el-tooltip content="可生产数量：根据物料库存数量，以及关联BOM清单中设定的物料标准用量及其损耗率计算所得。" placement="top" effect="light">
                        <span class="icon el-icon-question"></span>
                      </el-tooltip>
                    </p>
                  </div>
                </div>
                <span v-else class="no-bom">请选择BOM后模拟生产</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btnGroup">
        <el-button class="save" type="warning" @click="oneKey" :disabled="afterSimulation">一键生产</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from 'src/api'
import { mapGetters, mapActions } from 'vuex'
import { Message } from 'element-ui'
import lightBox from 'src/plugins/lightbox'
import bomField from 'components/fieldtype/product-manage/bom-field.vue' // bom

export default {
  props: {
    barcodeParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      simulationItem: {
        isRedundant: 0,
        attrValue: '',
        attr: 'bomId',
        fieldType: 0
      },
      // 要提交的数据
      simulationForm: {
        bomId: {}, // bomId
        materiel: [], // 提交物料产品
        canNum: 0, // 可生产数量
        type: 'simulationProduce' // 一键生产类型
      },
      bomName: '', // bom名称
      bomNo: '', // bom编号
      bomVersion: '', // bom版本号
      bomObj: {}, // BOM相关
      loading: false,
      materielExplains: [], // 物料产品字段
      materielTableData: [], // 物料产品
      finishedProduct: {}, // 成品产品
      compareObj: {}, // 用来比较大小
      checkout: false, // 校验
      afterSimulation: true //  判断是否可点击一键生产
    }
  },
  created () {},
  mounted () {
    this.initList('simulationProduce')
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ])
  },
  methods: {
    // 初始化
    ...mapActions([
      'initList'
    ]),

    // 选择bom后获得成品和物料
    bomChange (obj) {
      console.log(878, obj)
      this.bomObj = ''
      this.bomNo = ''
      this.afterSimulation = true
      if (obj.id) {
        this.bomObj = obj
      }
    },

    // 仓库改变时清空批次信息和改变库
    changeWareHouse (index, val) {
      let unitNum = 1
      let attritionRate = 0
      let stock = 0
      let decimalPrecision = 6
      this.materielTableData[index].result.map((item) => {
        if (item.attr === 'stock') {
          if (val.num === 0 || val.num) {
            item.attrValue = val.num
            stock = item.attrValue
          }
        }
        if (item.attr === 'unitNum') {
          unitNum = item.attrValue // 标准用量
          decimalPrecision = item.decimalPrecision
        }
        if (item.attr === 'attritionRate') {
          attritionRate = item.attrValue // 损耗率
        }
      })
      //  计算可生产数量
      let itemCanNum = stock * (1 - (attritionRate / 100)) / unitNum
      let plusNum = Number(itemCanNum.toFixed(decimalPrecision))
      if (plusNum < 0) {
        plusNum = 0
      }
      this.compareObj[this.materielTableData[index].id] = plusNum
      let compareArr = []
      for (let i in this.compareObj) {
        compareArr.push(this.compareObj[i])
      }
      this.simulationForm.canNum = Math.min.apply(null, compareArr)
    },

    // 开始模拟
    startSimulation () {
      this.loading = true
      this.afterSimulation = false
      this.simulationForm.canNum = 0 // 可生产数量初始为0
      this.compareObj = {} // 清空比较大小
      if (this.bomObj.id) {
        this.simulationForm.bomId.id = this.bomObj.id
        this.bomVersion = this.bomObj.version
        this.bomName = this.bomObj.name
        this.bomNo = this.bomObj.value
        let url = `/bomBill/bomBillProductList.html`
        let params = {
          bomBillId: this.bomObj.id,
          refType: 'simulationProduce'
        }
        api.post(url, params, (data) => {
          this.loading = false
          this.materielExplains = data.materiel.explains
          this.materielTableData = data.materiel.productList
          this.finishedProduct = data.finishedProduct.productList[0]
        }, (errorData) => {
          this.loading = false
        })
      }
    },

    // 一键生产
    oneKey () {
      this.simulationForm.materiel = this.proformData(this.materielTableData)
      if (!this.simulationForm.canNum) {
        Message({
          type: 'error',
          message: '可生产数量为0，不可一键生产'
        })
        return false
      }
      if (!this.checkout) {
        this.checkout = false
        let query = {
          moduleName: 'productionOrder'
        }
        let params = this.simulationForm
        this.$router.push({
          name: 'jxcAddPage',
          query: query,
          params: params
        })
      }
    },

    // 格式物料
    proformData (arrPro) {
      let productList = []
      let count = 0 // 判断仓库是否全选了
      arrPro.map((obj) => {
        let proObj = {}
        proObj.id = obj.id
        obj.result.map((item) => {
          if (item.attr === 'stock') {
            proObj[item.attr] = item.attrValue
          }
          if (item.attr === 'warehouse') {
            if (item.attrValue) {
              proObj[item.attr] = item.attrValue
              count++
            } else {
              Message({
                type: 'error',
                message: '请选择出库仓库'
              })
              this.checkout = true
              return
            }
          }
        })
        productList.push(proObj)
      })
      if (count === arrPro.length) {
        this.checkout = false
      }
      return productList
    },

    // 图片放大
    imgBig (item) {
      lightBox(item)
    }
  },
  components: {
    bomField
  },
  watch: {
    simulationForm: {
      handler () {
        console.log(88, this.simulationForm)
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .simulation-produce {
    .version {
      display: inline-block;
      width: 50px;
      height: 20px;
      line-height: 20px;
      background-color: rgba(252, 242, 222, 1);
      color: rgba(254, 157, 79, 1);
      font-size: 11px;
      text-align: center;
      margin: 0 8px 0 8px;
    }
    .hint {
      line-height: 16px;
      color: rgba(255, 124, 53, 1);
      font-size: 11px;
    }
    .children-head {
      position: relative;
      height: 60px;
      background-color: #fff;
      text-align: right;
      font-size: 0;
      flex: 0 0 60px;
      .title {
        position: absolute;
        left: 20px;
        color: #222;
        font-size: 16px;
        line-height: 60px;
        margin-left: 0px;
      }
    }
    .commun-wrap {
      position: relative;
      flex: 1 1 auto;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      margin: 10px;
      padding: 15px;
      overflow: auto;
      .field-out {
        .item-select {
          width: 300px;
          display: inline-block;
        }
        .simulated {
          display: inline-block;
        }
      }
      .simulation-table {
        .tableclass {
          border: 1px solid #dfe6ec;
          width:100%;
          margin-top:10px
        }
        .tableclass tr td {
          border-bottom: 1px solid #dfe6ec;
          border-right: 1px solid #dfe6ec;
          padding:3px 10px;
          text-align: left;
          vertical-align: middle;
          line-height: 30px;
          padding:10px;
        }
        .tableclass tr td:first-of-type {
          background: #eef1f6;
          width: 100px;
        }
        .tableclass tr td:last-of-type {
          border-right: none;
        }
        .tableclass tr:last-of-type td {
          border-bottom: none;
        }
        .ed-product {
          display: flex;
          img {
            width: 80px;
            height: 80px;
            cursor: pointer;
          }
          .product-Info {
            padding-left: 15px;
            width: 35%;
          }
          .product-Num {
            color: #ff7c35;
            .icon {color: #666;}
          }
        }
        .no-bom {
          color: @light-ash;
        }
      }
      //保存
      .btnGroup {
        text-align: center;
        padding: 34px 0 14px;
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        .save {
          background:#ff7c35;
          padding: 8px 24px;
          margin-right: 15px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// index.vue?5b43ff40